/*
    filter 邏輯
    1. init(is_first=true) =>
        1. query_to_filter
        2. fetch_core_waybills
            1. filter_to_api_query
            2. axios
        if (is_first) {
            3. handle_quick_filter_key ui 決定要顯示哪個filter 樣式
        }
    2. filter() =>
        1. filter_to_query
        2. routes.push() 觸發 watch_routes()

    3. watch_routes() =>
        1. init(false)
 */
import moment from "moment"
import ResponseError from '@javascripts/response_error.js'

const store = {
    namespaced: true,
    state: {
        current_form_entity_type: true,
        current_core_waybill: {},
        core_waybills: [],
        current_page: 1,
        total_pages: 1,

        search_cache_key: null,
        before_api_query: "",
        quick_filters: {
            number: ["original_number", "tracking_number", "number", "operation_number", "flight_number", "storage_number", "warehouse_identity", "original_number_2", "original_number_3", "original_number_4", "original_number_5"],
            info: ["sender_name", "sender_company_name", "divider", "consignee_name", "consignee_company_name", "consignee_phone", "consignee_address", "divider", "note", "shipping_note"],
            status: ["name"],
        },
        quick_filter_key: {
            number: "original_number",
            info: "sender_name",
            status: "latest_status",
        },
        is_where_like_filter_mode: false,
        filter_init: {
            page: 1,
            number: null,
            original_number: null,
            tracking_number: null,
            flight_number: null,
            sender_name: null,
            consignee_name: null,
            consignee_phone: null,
            consignee_address: null,
            note: null,
            is_used: null,
            created_at: {},
            shipping_date: {},
            operation: {
                number: null,
            },
            material: {
                class_names: null,
            },
            condition: {
                current_operator_identity: null,
                current_location: null,
                polarity: null,
                name: null,
                updated_at: {},
            },
            status: {
                operator_identity: null,
                location: null,
                scope: null,
                name: null,
                created_at: {},
            },
        },
        filter: {
            page: 1,
            created_at: {},
            shipping_date: {},
            operation: {},
            material: {},
            condition: {
                polarity: null,
                updated_at: {},
            },
            status: {
                scope: null,
                name: null,
                created_at: {},
            },
        },
        is_filter_async: false,
        is_show_filter: {
            simple: false,
            detail: false,
        },
        is_can_print_label: false,
        staffs: [],
        materials: [],
        scan_action_prototypes: [],
        condition_status_prototypes: [],
        converters: [],

        tool_label: {
            core_waybill_length: 0,
            numbers: '',
            label_name: "",
        },

        // csv
        csv: {
            is_processing: false,
            url: null
        },

        // new.vue
        customers: [],

        core_waybill_conditions: [
            "current_release",
            "current_handover",
            "current_collect",
            "current_check",
            "current_ship",
            "current_back",
            "current_delivered",
            "current_transfer",
            "current_intermodal",
            "current_exception",
            "current_lock",
            "current_done",
            "current_use",
            "divider",
            "already_use",
            "already_release",
            "already_handover",
            "already_collect",
            "already_check",
            "already_ship",
            "already_back",
            "already_delivered",
            "already_transfer",
            "already_intermodal",
            "already_exception",
            "already_lock",
            "already_done",
            "divider",
            "can_use",
            "can_release",
            "can_handover",
            "can_collect",
            "can_check",
            "can_ship",
            "can_back",
            "can_delivered",
            "can_transfer",
            "can_intermodal",
            "can_exception",
            "can_lock",
            "can_done",
            "can_warehouse_in",
            "current_warehouse_in",
            "already_warehouse_in",
            "can_warehouse_out",
            "current_warehouse_out",
            "already_warehouse_out",
            "can_ready_to_ship",
            "current_ready_to_ship",
            "already_ready_to_ship",
        ]
    },
    getters: {
        customer(state, getters, rootState, rootGetters) {
            return (identity) => {
                return _.findLast(state.customers, (customer) => {
                    return customer.identity == identity
                }) || {}
            }
        },
        // filter 平面化 輸出一層object
        filter_to_query(state, getters, rootState, rootGetters) {
            let filter = _.cloneDeep(state.filter)
            if (filter.page) delete filter.page
            if (filter.search_cache_key) delete filter.search_cache_key

            if (filter.status.created_duration) {
                if (filter.status.created_duration[0]) filter.status_created_at_from = moment(filter.status.created_duration[0]).format("YYYY-MM-DD")
                if (filter.status.created_duration[1]) filter.status_created_at_to = moment(filter.status.created_duration[1]).format("YYYY-MM-DD")
            }

            if (filter.condition.updated_duration) {
                if (filter.condition.updated_duration[0]) filter.condition_updated_at_from = moment(filter.condition.updated_duration[0]).format("YYYY-MM-DD")
                if (filter.condition.updated_duration[1]) filter.condition_updated_at_to = moment(filter.condition.updated_duration[1]).format("YYYY-MM-DD")
            }

            if (filter.shipping_date_duration) {
                if (filter.shipping_date_duration[0]) filter.shipping_date_from = moment(filter.shipping_date_duration[0]).format("YYYY-MM-DD")
                if (filter.shipping_date_duration[1]) filter.shipping_date_to = moment(filter.shipping_date_duration[1]).format("YYYY-MM-DD")
            }

            if (filter.created_duration) {
                if (filter.created_duration[0]) filter.created_at_from = moment(filter.created_duration[0]).format("YYYY-MM-DD")
                if (filter.created_duration[1]) filter.created_at_to = moment(filter.created_duration[1]).format("YYYY-MM-DD")
            }

            if (filter.condition_updated_duration) delete filter.condition_updated_duration
            if (filter.status_created_duration) delete filter.status_created_duration
            if (filter.shipping_date_duration) delete filter.shipping_date_duration
            if (filter.created_duration) delete filter.created_duration

            _.forEach(filter, (value, key) => {
                if (value && typeof value === 'object') {
                    _.forEach(value, (item_val, item_key) => {
                        if (filter[key][item_key]) {
                            filter[key+'_'+item_key] = item_val
                            delete filter[key][item_key]
                        }
                    })
                }
            })

            if (filter.condition_updated_duration) delete filter.condition_updated_duration
            if (filter.status_created_duration) delete filter.status_created_duration
            if (filter.shipping_date_duration) delete filter.shipping_date_duration
            if (filter.created_duration) delete filter.created_duration

            if (!filter.condition.name && filter.condition_polarity) {
                delete filter.condition_polarity
            }
            return object_delete_null(filter)
        },
        filter_to_api_query(state, getters, rootState, rootGetters) {
            return (payload = {}) => {
                let filter = _.cloneDeep(state.filter)

                if (payload.is_remove_page) {
                    if (filter.page) delete filter.page
                }

                if (filter.status.created_duration) {
                    if (filter.status.created_duration[0]) filter.status.created_at.from = date_to_start(filter.status.created_duration[0])
                    if (filter.status.created_duration[1]) filter.status.created_at.to = date_to_end(filter.status.created_duration[1])
                    delete filter.status.created_duration
                }

                if (filter.condition.updated_duration) {
                    if (filter.condition.updated_duration[0]) filter.condition.updated_at.from = date_to_start(filter.condition.updated_duration[0])
                    if (filter.condition.updated_duration[1]) filter.condition.updated_at.to = date_to_end(filter.condition.updated_duration[1])
                    delete filter.condition.updated_duration
                }

                if (filter.created_duration) {
                    if (filter.created_duration[0]) filter.created_at.from = date_to_start(filter.created_duration[0])
                    if (filter.created_duration[1]) filter.created_at.to = date_to_end(filter.created_duration[1])
                    delete filter.created_duration
                }

                if (filter.shipping_date_duration) {
                    if (filter.shipping_date_duration[0]) filter.shipping_date.from = date_to_start(filter.shipping_date_duration[0])
                    if (filter.shipping_date_duration[1]) filter.shipping_date.to = date_to_end(filter.shipping_date_duration[1])
                    delete filter.shipping_date_duration
                }

                // where_like add %% staring
                if (state.is_where_like_filter_mode) {
                    _.forEach([
                        "number",
                        "flight_number",
                        "original_number",
                        "tracking_number",
                        "sender_name",
                        "sender_company_name",
                        "consignee_name",
                        "consignee_company_name",
                        "consignee_address",
                        "consignee_phone",
                        "note"
                    ], (name) => {
                        if (filter[name]) {
                            filter[name] = "%"+filter[name]+"%"
                        }
                    })

                    if (filter.operation.number) {
                        filter.operation.number = "%"+filter.operation.number+"%"
                    }
                }

                if (payload.merge) {
                    filter = {...filter, ...payload.merge}
                }

                return object_to_query(filter)
            }
        },
    },
    actions: {
        fetch_customer(context, payload = {}) {
            if (!context.getters.customer(payload.customer_identity).identity) {
                var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_customer).parse(
                    {customer_identity: payload.customer_identity},
                )
                return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            context.commit('set_push_customers', response.data.customer)
                        } else {
                            return Promise.reject('fetch_customer_failure')
                        }
                    })
            }
        },
        fetch_core_waybills(context, payload = {}) {
            var that = this

            context.commit('set_tool_label', {
                core_waybill_length: 0,
                numbers: '',
                label_name: "",
            })
            var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_filter)
            var url = rest_url.parse(
                {},
            )

            let api_query = context.getters.filter_to_api_query()
            context.state.is_can_print_label = (api_query) ? true : false
            if (api_query) url += `?${api_query}`
            // url = url + "&latest_status_scope=operator"

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_search_cache_key', response.data.search_cache_key)
                        context.commit('set_core_waybills', response.data.core_waybills)
                        context.commit('set_pagination', response.data.pagination)

                        if (!response.data.core_waybills.length) {
                            return Promise.reject('fetch_core_waybills_no_anything_core_waybills')
                        }

                        if (payload.action == "edit") {
                            console.log('response.data.core_waybills[0]', response.data.core_waybills[0])
                            if (response.data.core_waybills.length) {
                                that.$router.push({
                                    name: 'edit_core_waybill',
                                    params: {identity: response.data.core_waybills[0].identity}
                                })
                            } else {
                                return Promise.reject('fetch_core_waybills_no_anything_core_waybills')
                            }
                        }
                    } else {
                        return Promise.reject('fetch_core_waybills_failure')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        fetch_core_waybills_by_async(context, payload = {}) {
            var that = this
            var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_filter)
            var url = rest_url.parse(
                {},
            )

            let api_query = context.getters.filter_to_api_query()
            context.state.is_can_print_label = (api_query) ? true : false
            if (api_query) url += `?${api_query}`
            url = url + "&is_async=true"

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        //
                        // context.commit('set_search_cache_key', response.data.search_cache_key)
                        // context.commit('set_core_waybills', response.data.core_waybills)
                        // context.commit('set_pagination', response.data.pagination)
                        //
                        // if (!response.data.core_waybills.length) {
                        //     return Promise.reject('fetch_core_waybills_no_anything_core_waybills')
                        // }
                        //
                        // if (payload.action == "edit") {
                        //     console.log('response.data.core_waybills[0]', response.data.core_waybills[0])
                        //     if (response.data.core_waybills.length) {
                        //         that.$router.push({
                        //             name: 'edit_core_waybill',
                        //             params: {identity: response.data.core_waybills[0].identity}
                        //         })
                        //     } else {
                        //         return Promise.reject('fetch_core_waybills_no_anything_core_waybills')
                        //     }
                        // }
                    } else {
                        return Promise.reject('fetch_core_waybills_failure')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        export_core_waybills(context, payload = {}) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_export).parse(
                {search_cache_key: context.state.search_cache_key}
            )
            if (payload.converter_identity) {
                url += `?converter_identity=${payload.converter_identity}`
            }
            console.log(url);
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {

                    } else {
                        return Promise.reject()
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        fetch_staffs(context, payload) {
            if (context.state.staffs.length) return Promise.resolve()
            var url = context.rootState.provider.routes.api_v1_provider_staffs + "?pagination=false"
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_staffs', response.data.staffs)
                    } else {
                        return Promise.reject('fetch_staffs_failure')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        fetch_materials(context, payload) {
            if (context.state.materials.length) return Promise.resolve()
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_materials).parse(
                {},
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_materials', response.data.materials)
                    } else {
                        return Promise.reject('fetch_materials_failure')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        fetch_scan_action_prototypes(context, payload) {
            if (context.state.scan_action_prototypes.length) return Promise.resolve()
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_scan_action_prototypes).parse(
                {},
                "?pagination=false"
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_scan_action_prototypes', response.data.scan_action_prototypes)
                    } else {
                        return Promise.reject('fetch_scan_action_prototypes_failure')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        fetch_converters(context, payload) {
            if (context.state.converters.length) return Promise.resolve()
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_file_converters).parse(
                {},
                "?pagination=false"
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_converters', response.data.converters);
                    } else {
                        return Promise.reject('fetch_converters')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        fetch_core_waybills_pagination_false(context, payload) {
            console.log('fetch_core_waybills_pagination_false');
            let api_query = context.getters.filter_to_api_query({
                is_remove_page: true
            })

            if (!api_query) {
                context.commit('set_tool_label', {
                    core_waybill_length: 0,
                    numbers: '',
                    label_name: "",
                })
                return Promise.reject('fetch_core_waybills_pagination_false nothing filter')
            }

            var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_filter)
            var url = rest_url.parse(
                {},
            )

            url += "?pagination=false"
            if (api_query) url += `&${api_query}`

            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_tool_label', {
                        core_waybill_length: 0,
                        numbers: '',
                        label_name: '',
                    })

                    if (response.data.status == "success") {
                        console.log(_.groupBy(response.data.core_waybills, 'label_type'));
                        var label_name = _.groupBy(response.data.core_waybills, 'label_type')
                        var error, numbers, core_waybill_length = 0
                        // if (Object.keys(label_name) != "" && Object.keys(label_name).length == 1) {
                            let number_objects = []
                            
                            _.forEach(response.data.core_waybills, (e) => {
                                if (!isNaN(parseInt(e.note_2))) {
                                    for (let i = 1; i <= parseInt(e.note_2); i++) {
                                        number_objects.push(
                                            {
                                                number: e.number,
                                                count: parseInt(e.note_2),
                                                serial: i
                                            }
                                        )
                                    }
                                    core_waybill_length += parseInt(e.note_2);
                                } else {
                                    number_objects.push(
                                        {
                                            number: e.number,
                                            count: 1,
                                            serial: 1
                                        }
                                    )
                                    core_waybill_length += 1;
                                }
                            })
                            // core_waybill_length = response.data.core_waybills.length,
                            // numbers = _.map(response.data.core_waybills, 'number')
                            label_name = Object.keys(label_name)[0];

                            context.commit('set_tool_label', {
                                core_waybill_length: core_waybill_length,
                                numbers: number_objects,
                                label_name: label_name || "Label::Default",
                            })
                        // } else {
                        //     return Promise.reject('core_waybills_label_type_different')
                        // }
                    } else {
                        return Promise.reject('fetch_core_waybills_pagination_false_error')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        fetch_core_waybills_csv_new(context, payload) {
            try {
                var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_report_job).parse()

                console.log(url)
                return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        context.state.csv.is_processing = true
                        context.state.csv.url = null

                        if (response.data.status == "success") {
                            return Promise.reject('success')
                        } else {
                            return Promise.reject('errores')
                        }
                    })

                if (context.state.csv.is_processing) {
                    throw "fetch_core_waybills_csv_loading"
                }

                if (!context.state.csv.url) {
                    throw "fetch_core_waybills_csv_error"
                }

            } catch (e) {
                console.log(e)
                return Promise.reject(e)
            }
        },
        fetch_core_waybills_csv(context, payload) {
            let timestamp = Math.floor(Date.now() / 1000)
            let csv_tpye_string = payload.type ? "&csv_tpye="+payload.type : null
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_filter + ".csv").parse(
                {},
                "?v=" + timestamp + csv_tpye_string
            )

            console.log('fetch_core_waybills_csv');
            let api_query = context.getters.filter_to_api_query({
                is_remove_page: true
            })
            if (api_query) url += `&${api_query}`

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        var downloadLink = document.createElement("a")
                        var blob = new Blob(["\ufeff", response.data.csv])
                        var url = URL.createObjectURL(blob)
                        var file_name_note = payload.type == 'clearance' ? "_清關" : ""
                        downloadLink.href = url
                        downloadLink.download = moment().format('YYYY-MM-DD HH:mm:ss') + file_name_note + ".csv"
                        document.body.appendChild(downloadLink)
                        downloadLink.click()
                        document.body.removeChild(downloadLink)
                    } else if (response.data.status == "failure") {
                        return Promise.reject('fetch_core_waybills_svg_error')
                    }
                })
                .catch(error => {
                    return Promise.reject('fetch_core_waybills_svg_error')
                })
        },
        // query 轉成 filter格式 並 merge 到 filter
        handle_query_to_filter(context, payload = {}) {
            if (payload.query) {
                let query = {..._.cloneDeep(context.state.filter_init), ..._.cloneDeep(payload.query)}

                if (query.condition_name) {
                    query.condition.polarity = "true"
                }

                // {
                //     key: val,
                //     key: val,
                //     items: {
                //         item_key: item_val,
                //         item_key: item_val,
                //     }
                // }
                // 將filter_init 內的的object 轉換成 駝峰格式 並判斷有該query 則使用query的值
                _.forEach(context.state.filter_init, (value, key) => {
                    if (value && typeof value === 'object') {
                        _.forEach(value, (item_val, item_key) => {
                            if (query[key+'_'+item_key]) {
                                query[key][item_key] = query[key+'_'+item_key]
                                delete query[key+'_'+item_key]
                            }
                        })
                    }
                })

                if (query.status_created_at_from && query.status_created_at_to) {
                    query.status.created_duration = [
                        moment(query.status_created_at_from) || "",
                        moment(query.status_created_at_to) || ""
                    ]
                    delete query.status_created_at_from
                    delete query.status_created_at_to
                }

                if (query.condition_updated_at_from && query.condition_updated_at_to) {
                    query.condition.updated_duration = [
                        moment(query.condition_updated_at_from) || "",
                        moment(query.condition_updated_at_to) || ""
                    ]
                    delete query.condition_updated_at_from
                    delete query.condition_updated_at_to
                }

                if (query.shipping_date_from && query.shipping_date_to) {
                    query.shipping_date_duration = [
                        moment(query.shipping_date_from) || "",
                        moment(query.shipping_date_to) || ""
                    ]
                    delete query.shipping_date_from
                    delete query.shipping_date_to
                }

                if (query.created_at_from && query.created_at_to) {
                    query.created_duration = [
                        moment(query.created_at_from) || "",
                        moment(query.created_at_to) || ""
                    ]
                    delete query.created_at_from
                    delete query.created_at_to
                }

                context.state.filter = {...context.state.filter, ...query}
            }
        },
        // only run in init()
        handle_quick_filter_key(context, payload = {}) {
            let filter = object_delete_null(
                _.cloneDeep(context.state.filter)
            )

            if (filter.page) delete filter.page
            if (filter.search_cache_key) delete filter.search_cache_key

            let filter_length = Object.keys(filter).length
            let quick_filter_keys_occurrence_number = {
                number: 0,
                number_last_key: "",
                info: 0,
                info_last_key: "",
            }

            if(filter.operation && filter.operation.number) {
                quick_filter_keys_occurrence_number.number += 1
                quick_filter_keys_occurrence_number.number_last_key = 'operation_number'
            }
            context.state.quick_filters.number.forEach((key) => {
                if(filter[key]) {
                    quick_filter_keys_occurrence_number.number += 1
                    quick_filter_keys_occurrence_number.number_last_key = key
                }
            })

            context.state.quick_filters.info.forEach((key) => {
                if(filter[key]) {
                    quick_filter_keys_occurrence_number.info += 1
                    quick_filter_keys_occurrence_number.info_last_key = key
                }
            })

            if (quick_filter_keys_occurrence_number.number == 1) {
                context.state.quick_filter_key.number = quick_filter_keys_occurrence_number.number_last_key
            }
            if (quick_filter_keys_occurrence_number.info == 1) {
                context.state.quick_filter_key.info = quick_filter_keys_occurrence_number.info_last_key
                context.state.is_show_filter.simple = true
            }

            if (
                (
                    quick_filter_keys_occurrence_number.number == 0 &&
                    quick_filter_keys_occurrence_number.info == 0 &&
                    filter_length >= 1
                ) || (
                    quick_filter_keys_occurrence_number.number >= 2
                ) || (
                    quick_filter_keys_occurrence_number.info >= 2
                )
            ) {
                context.state.is_show_filter.simple = false
                context.state.is_show_filter.detail = true
            }

            if (
                quick_filter_keys_occurrence_number.number <= 1 &&
                quick_filter_keys_occurrence_number.info <= 1 &&
                filter_length > 2
            ) {
                context.state.is_show_filter.simple = false
                context.state.is_show_filter.detail = true
            }
        },
        clear_filter(context, payload = {}) {
            context.commit('set_filter', _.cloneDeep(context.state.filter_init))

            if (payload.operation_number) {
                context.state.filter.operation.number = payload.operation_number
            }
        },
        set_filter_init(context, payload) {
            context.commit('set_filter', _.cloneDeep(context.state.filter_init))
        },
        set_filter_kay_value(context, payload) {
            context.commit('set_filter_kay_value', payload)
        },
    },
    mutations: {
        set_core_waybills(state, payload) {
            state.core_waybills = payload
        },
        set_search_cache_key(state, payload) {
            state.search_cache_key = payload
        },
        // new.vue
        set_push_customers(state, payload) {
            state.customers.push(payload)
        },
        set_staffs(state, payload) {
            state.staffs = payload
        },
        set_materials(state, payload) {
            state.materials = payload
        },
        set_scan_action_prototypes(state, payload) {
            state.scan_action_prototypes = payload
        },
        set_converters(state, payload) {
            state.converters = payload
        },
        set_tool_label(state, payload) {
            state.tool_label = payload
        },
        set_pagination(state, payload) {
            state.current_page = payload.current_page
            state.total_pages = payload.total_pages
        },
        set_filter(state, payload) {
            state.filter = payload
        },
        set_filter_kay_value(state, payload) {
            state.filter[payload.key] = payload.value
        },
    }
}

export default store
